module.exports = Promise.resolve(module.bundle.root("9ve9c"))